import useSWR from "swr";
import { ago, baseOf, fetcher } from "@/lib/api";

const TONE = { positive: "text-[#0ecb81]", negative: "text-[#f6465d]", neutral: "text-[#848e9c]" };

export function NewsPulse({ symbol, limit = 12 }) {
  const { data } = useSWR(symbol ? `/market/news?symbol=${symbol}` : `/market/news?limit=${limit}`, fetcher, { refreshInterval: 300000 });
  if (!data) return <div className="panel p-3 text-xs text-[#5e6673]">Loading news…</div>;
  const items = symbol ? [...data.asset_headlines, ...data.market_headlines.filter((m) => !data.asset_headlines.includes(m))].slice(0, limit) : data.items;
  const pulse = symbol ? data.pulse : null;
  return (
    <div className="panel p-3" data-testid="news-pulse">
      <div className="flex items-center justify-between mb-2">
        <div className="panel-title">News Pulse {symbol ? `· ${baseOf(symbol)}` : ""} <span className="text-[#5e6673] normal-case tracking-normal">RSS · CoinDesk, Cointelegraph, Decrypt</span></div>
        {pulse && <span className={`pill bg-[#1e2329] ${TONE[pulse]}`} data-testid="news-pulse-badge">{pulse.toUpperCase()} TONE</span>}
      </div>
      {symbol && data.themes?.length > 0 && <div className="flex flex-wrap gap-1 mb-2" data-testid="news-themes">{data.themes.map((t) => <span key={t} className="pill bg-[#2b3139] text-[#eaecef]">{t}</span>)}</div>}
      <div className="space-y-1.5 max-h-[420px] overflow-y-auto">
        {items.length === 0 && <div className="text-xs text-[#5e6673] text-center py-4">No headlines available</div>}
        {items.map((n, i) => (
          <a key={`${n.url}${i}`} href={n.url} target="_blank" rel="noopener noreferrer" className="block hover:bg-[#1e2329] rounded px-2 py-1.5 transition-colors" data-testid="news-item">
            <div className="text-[12px] text-[#eaecef] leading-snug">{n.title}</div>
            <div className="flex flex-wrap items-center gap-2 mt-0.5 text-[10px] mono">
              <span className="text-[#5e6673]">{n.source}</span><span className="text-[#5e6673]">{n.published_at ? ago(new Date(n.published_at).toISOString()) : ""}</span>
              <span className={TONE[n.tone]}>{n.tone}</span>
              {n.symbols.map((s) => <span key={s} className="text-[#fcd535]">{s}</span>)}
              {n.themes.map((t) => <span key={t} className="text-[#848e9c]">#{t}</span>)}
            </div>
          </a>
        ))}
      </div>
      <div className="text-[10px] text-[#5e6673] mt-2">Headlines are FACTs (titles only, keyword-tagged). The AI reads them as backdrop — it never invents news content.</div>
    </div>
  );
}
